var throttle = require('lodash.throttle')
//var debounce = require('lodash.debounce')
//var theme_url = "http://ansi.local:8888/wp-content/themes/ansi"
var animatedScroll = require('./animated-scroll')

window.onload = function () {
	
	var html = document.getElementsByTagName('html')[0]

	var lSection = document.getElementsByClassName('container--landing')[0]
	var svgPath = document.getElementsByClassName('svg-path')[0]
	var lbg = document.getElementsByClassName('landing-bg')[0]
	var lma = document.getElementsByTagName('svg')[0]
	var lmaIE = document.getElementsByClassName('landing-mask ie')[0]

	var header = document.getElementsByClassName('header')[0]
	var sections = document.getElementsByClassName('container')

	var transitonLayer = document.getElementsByClassName('transition-layer')[0]
	var pageLinks = document.getElementsByClassName('page-transition')

	var infoBtn = document.getElementsByClassName('header__wrapper--link')[0]
	var logoBtn = document.getElementsByClassName('header__wrapper--logo')[0]
	var titleBtn = document.getElementsByClassName('header__wrapper--title')[0]
	var logoFooter = document.getElementsByClassName('logo-element--footer')[0]
	var topBtnFooter = document.getElementsByClassName('link--top')[0]

	var noticeLayer = document.getElementsByClassName('notice-layer') // notice-layer top bottom array
	var noticeTimer = null // notice-layer scroll timer

	var overviewButtons = document.getElementsByClassName('overview__item')
	var toOverviewButton = document.getElementsByClassName('link--overview')[0]

	// vp-vars
	var SELECTOR = 'vp-element'
	var SHOW_OFFSET
	var HEADER_OFFSET
	var vpH

	// start animated transitions
	for (var i = pageLinks.length - 1; i >= 0; i--) {
		pageLinks[i].addEventListener('click', function (ev) {
			addClass(transitonLayer, 'visible')
		})
	}
	for (var i = sections.length - 1; i >= 0; i--) {
		addClass(sections[i], 'visible')
	}

	
	if (lSection == undefined || !lSection) { // functions for single-project page
		var vimeoIframe = document.getElementsByTagName('iframe')[0]
		
		addClass(vimeoIframe, 'visible')
		addClass(noticeLayer[0], 'visible')
		addClass(noticeLayer[1], 'visible')	
		for (var i = pageLinks.length - 1; i >= 0; i--) {
			pageLinks[i].addEventListener('click', function (ev) {
				if (ev.target.className.indexOf('link--back') <= -1) {
					addClass(transitonLayer, 'black')
				} else {						
					addClass(transitonLayer, 'lightgray')
				}
			})
		}
		window.addEventListener('scroll', function (ev) {
			var nLH = noticeLayer[1].getBoundingClientRect().height
			if (window.pageYOffset >= nLH) {
				removeClass(noticeLayer[1], 'visible')//noticeLayer.children[0].style.opacity = 0
				noticeLayer[1].style.cursor = 'auto'
			} else {
				addClass(noticeLayer[1], 'visible')//noticeLayer.children[0].style.opacity = 1
				noticeLayer[1].style.cursor = 's-resize'
			}
		})
	} else { // functions for landing page only
		// IE conditionals
		if (svgPath.getBoundingClientRect().width - html.getBoundingClientRect().width*0.9+2 > 5) {
			lmaIE.style.display = 'block' // replace svg with img (ie svg fix)
			lma.style.display = 'none'

			var bgels = document.getElementsByClassName('container__block--background__element') // bg-video size (ie video overflow fix)
			for (var i = bgels.length - 1; i >= 0; i--) {
				bgels[i].style.maxWidth = 'calc(100vw - 10px)'
			}

			var plinks = document.getElementsByClassName('container__block--link__element') // replace project-link with vimeo-link (ie vimeo-player embed workaround)
			for (var i = plinks.length - 1; i >= 0; i--) {
				plinks[i].children[0].href = plinks[i].children[0].dataset.iehref
				//plinks[i].children[0].target = '_blank'
			}
		}
		// touch conditionals
		if (Modernizr.touchevents == true) {
			//replace video src
			for (var i = document.getElementsByTagName('video').length - 1; i >= 0; i--) {
				document.getElementsByTagName('video')[i].src = ''
			}
			//replace mailto href (mobile mail-client workaround)
			document.getElementsByClassName('link--contact')[0].href = ''
		}

		// start animated transition
		addClass(header, 'visible')


		// elevator-action
		infoBtn.addEventListener('click', function (ev) {
			scrollToEl(logoFooter, sections, 1200)
			setTimeout(function(){
				html.style.background = '#00000'
			}, 1300)
		})
		logoBtn.addEventListener('click', function (ev) {
			scrollToEl(sections[0], sections, 1200)
			setTimeout(function(){
				svgPath.style.fill = '#F0F0F0'
				html.style.background = '#F0F0F0'
			}, 1300)
		})
		titleBtn.addEventListener('click', function (ev) {
			scrollToEl(sections[0], sections, 1200)
			setTimeout(function(){
				svgPath.style.fill = '#F0F0F0'
				html.style.background = '#F0F0F0'
			}, 1300)
		})
		topBtnFooter.addEventListener('click', function (ev) {
			scrollToEl(sections[0], sections, 1200)
			setTimeout(function(){
				svgPath.style.fill = '#F0F0F0'
				html.style.background = '#F0F0F0'
			}, 1300)
		})


		//overview-action
		for (var i = overviewButtons.length - 1; i >= 0; i--) {
			overviewButtons[i].addEventListener('click', function (ev) {
				for (var j = sections.length - 1; j >= 0; j--) {
					if (sections[j].getAttribute('data-slug') == ev.target.getAttribute('name')) {
						scrollToEl(sections[j], sections, 1200, 1)
					}
				}
			})
		}
		toOverviewButton.addEventListener('click', function () {
			scrollToEl(sections[1], sections, 1200)
		})


		// viewport-action
		var elements = Array.prototype.map.call(document.getElementsByClassName(SELECTOR), function(el) {
			return {
				el: el,
				top: undefined,
				bottom: undefined,
				title: el.getElementsByClassName('container__block--title')[0],
				link: el.getElementsByClassName('container__block--link')[0],
				bg: el.getElementsByClassName('container__block--background')[0],
				bgel: el.getElementsByClassName('container__block--background__element')[0],
				clr: el.dataset.color,
				images: el.getElementsByClassName('container__block--image__element')
			}
		})

		//var tScroll = throttle(vpScroll, 0)
		//var dResize = debounce(vpResize, 0)
		if (Modernizr.touchevents == false) {
			window.addEventListener('resize', vpResize)
			window.addEventListener('scroll', vpScroll)
		} else {
			html.style.height = window.screen.height+'px'
			logoFooter.style.height = window.screen.height/12+'px'

			var windowWidth = window.innerWidth
			window.addEventListener('resize', function (ev) {
				if (windowWidth != window.innerWidth) {
					html.style.height = window.screen.height+'px'
					logoFooter.style.height = window.screen.height/12+'px'
					vpResize()
				}
			})
			window.addEventListener('touchmove', vpScroll)
			
			elements.forEach(function (element) {
				addClass(element.link, 'animation--pulse')
			})
		}

		vpResize()
		vpScroll()

		function vpResize () {
			vpH = window.innerHeight
			var y = window.pageYOffset
			if (Modernizr.touchevents == false) {
				SHOW_OFFSET = lSection.getBoundingClientRect().height // top section height offset 	
			} else {
				SHOW_OFFSET = lSection.getBoundingClientRect().height*0.5 // top section height offset 
			}
			elements.forEach(function (element) {
				var bcr = element.el.getBoundingClientRect()
				element.top = bcr.top + y
				element.bottom = bcr.bottom + y
			})
			HEADER_OFFSET = header.getBoundingClientRect().height
			//console.log('resize')
		}

		function vpScroll () {
			var winTop = window.pageYOffset
			var winBottom = winTop + vpH

			// sticky header + landing video play/pause + notice-layer visibility
			if (winTop >= vpH - HEADER_OFFSET) {
				header.style.position = 'fixed'
				header.style.top = 0;
				header.style.bottom = 'auto';
				header.getElementsByTagName('span')[0].style.display = 'none'
				header.getElementsByTagName('span')[1].style.display = 'none' // smallscreen

				if (Modernizr.touchevents == false && !lbg.paused) {
					lbg.pause()
				}

				noticeLayer[0].style.opacity = 1
				toOverviewButton.style.display = 'block'
			} else {
				header.style.position = 'absolute'
				header.style.bottom = 0
				header.style.top = 'auto'
				header.getElementsByTagName('span')[0].style.display = 'block'
				header.getElementsByTagName('span')[1].style.display = 'block' // smallscreen

				if (Modernizr.touchevents == false && lbg.paused) {
					lbg.play()
				}

				noticeLayer[0].style.opacity = 0
				toOverviewButton.style.display = 'none'
			}


			// switch back to main html- & svg-color
			if (winTop <= SHOW_OFFSET) {
				svgPath.style.fill = '#F0F0F0'
				html.style.background = '#F0F0F0'
			} else if (winBottom >= getPageHeight() + SHOW_OFFSET*0.5) {
				html.style.background = '#000000'
				noticeLayer[0].style.opacity = 0
			}
			
			elements.forEach(function (element) {
				if (winTop + SHOW_OFFSET > element.bottom) {
					hide('top', element)
				} else if (winBottom - SHOW_OFFSET < element.top) {
					hide('bottom', element)
				} else {
					show(element)
				}
			})

			function hide (direction, element) {
				if (Modernizr.touchevents == false) {
					element.title.style.position = 'absolute'
					element.link.style.position = 'absolute'
					element.bg.style.position = 'absolute'
					if (direction == 'top') {
						element.title.style.top = element.bottom - vpH + 'px'
						element.link.style.top = element.bottom - vpH + 'px'
						element.bg.style.top = element.bottom - vpH + 'px'
						//console.log('h top')
					} else if (direction == 'bottom') {
						element.title.style.top = element.top + 'px'
						element.link.style.top = element.top + 'px'
						element.bg.style.top = element.top + 'px'
						//console.log('h bottom')
					}
					if (/*Modernizr.touchevents == false && */!element.bgel.paused) {
						element.bgel.pause()
					}
					for (var i = element.images.length - 1; i >= 0; i--) {
						element.images[i].style.filter = 'blur(8px)'
						element.images[i].style.webkitFilter = 'blur(8px)'
					}
					element.bg.style.opacity = 0.15
					element.link.style.opacity = 0
					removeClass(element.link, 'animation--pulse')
				}
			}
			function show (element) {
				if (Modernizr.touchevents == false) {
					element.title.style.position = 'fixed'
					element.link.style.position = 'fixed'
					element.bg.style.position = 'fixed'
					element.title.style.top = 0
					element.link.style.top = 0
					element.bg.style.top = 0
						loadDataSrc(element.el.previousElementSibling)
						loadDataSrc(element.el)
						loadDataSrc(element.el.nextElementSibling)
						if (element.bgel.paused) {
							element.bgel.play()
						}
					for (var i = element.images.length - 1; i >= 0; i--) {
						element.images[i].style.filter = 'blur(0px)'
						element.images[i].style.webkitFilter = 'blur(0px)'
					}
						element.bg.style.opacity = 1
						element.link.style.opacity = 1
						svgPath.style.fill = element.clr
						setTimeout(function () {addClass(element.link, 'animation--pulse')}, 1333)
				}
				svgPath.style.fill = element.clr
				html.style.background = element.clr
			}
		}
	}

	function loadDataSrc (el) {
		if (el != null) {
			if (el.getElementsByTagName('video').length >= 1) {
				var videoEl = el.getElementsByTagName('video')[0]
				if (videoEl.src != videoEl.dataset.source) {
					videoEl.src = videoEl.dataset.source
				}
			}
		}
	}

	var scrollToEl = function(el, els, duration, offset){ // els = elements to blur
		var _offset = (offset) ? offset : 0
		var pos = el.getBoundingClientRect().top + window.pageYOffset + _offset;
		animatedScroll({ to: pos, els: els, duration: duration }, function(){})
	}


	function getPageHeight() {
		var heights = []
		for (var i = 0; i < sections.length - 1; i++) { // '-1' excludes footer height
			heights.push(sections[i].getBoundingClientRect().height)
		}
		return heights.reduce(add, 0)
	}

	function add(a, b) { return a + b }

	function addClass (el, cn) {
		if(el){
			if(el.className.indexOf(cn) == -1){
				el.className += ' '+cn
				return el
			}
		}
	}

	function removeClass (el, cn) {
		if(el){
			if(el.className.indexOf(cn) > -1){
				el.className = el.className.replace(' '+cn, '')
				return el
			}
		}
	}

	function toggleClass (el, cn){
		if(el.className.indexOf(cn) == -1){
			el.className += ' '+cn
			return el
		} else {
			el.className = el.className.replace(' '+cn, '')
			return el
		}
	}

}


// WEBPACK FOOTER //
// ./scripts/main.js